import { getBffUrl as bffUrlSelector } from 'selectors'
import store from '../store'

import * as Api from '../utils/api'

const getBffUrl = () => bffUrlSelector(store.getState())

export const search = body => Api.post(
  `${getBffUrl()}/contacts_management/journalists`, body
)

export const importJournalists = body => Api.post(
  `${getBffUrl()}/contacts_management/journalists/import`, body
)

export const loadJournalistNews = (journalistId, body) => Api.post(
  `${getBffUrl()}/contacts_management/journalists/${journalistId}/news`, body
)

export const findPublications = body => Api.post(
  `${getBffUrl()}/contacts_management/journalists/find_publications`, body
)

export const findJobTitles = body => Api.post(
  `${getBffUrl()}/contacts_management/journalists/find_job_titles`, body
)
